export const activities = [
  {
    slug: "escalada",
    image: "/assets/escalada.jpg",
    gallery: [
      "/assets/escalada.jpg",
    ],
    duration: { es: "4 - 6 horas", en: "4 - 6 hours" },
    difficulty: { es: "Iniciación a Deportiva", en: "Beginner to Sport" },
    group: { es: "Mín. 2 - Máx. 6 personas", en: "Min. 2 - Max. 6 people" },
    price: "Desde 70€",
    priceEn: "From €70",
    title: { es: "Escalada en Roca", en: "Rock Climbing" },
    tagline: {
      es: "Vertical, vistas infinitas y la roca como única regla.",
      en: "Vertical, endless views and the rock as the only rule.",
    },
    description: {
      es: "Disfruta de la escalada en algunas de las paredes más emblemáticas del Norte. Sesiones para iniciarte por primera vez o vías deportivas para quienes ya escalan. Material homologado, guía técnico y aseguramiento desde el suelo. Aprenderás a moverte por la pared con seguridad, gestionar el miedo y disfrutar de la altura.",
      en: "Climb on some of the most iconic walls of the North. First-timer sessions or sport routes for those already climbing. Certified gear, technical guide and ground belay. You'll learn to move safely on the wall, manage fear and enjoy heights.",
    },
    includes: {
      es: [
        "Arnés, casco, pies de gato y material técnico",
        "Cuerdas, cintas express y aseguramiento",
        "Guía técnico deportivo titulado",
        "Seguro de accidentes y RC",
        "Briefing de progresión y nudos básicos",
      ],
      en: [
        "Harness, helmet, climbing shoes and technical gear",
        "Ropes, quickdraws and belay",
        "Qualified technical sports guide",
        "Accident & liability insurance",
        "Progression and basic knots briefing",
      ],
    },
  },
  {
    slug: "barrancos",
    image: "https://images.unsplash.com/photo-1774982625681-7f9178c2ecfe?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTV8MHwxfHNlYXJjaHwzfHxjYW55b25pbmclMjBhZHZlbnR1cmV8ZW58MHx8fHwxNzgwODU3OTYyfDA&ixlib=rb-4.1.0&q=85",
    gallery: [
      "https://images.unsplash.com/photo-1721338752673-91b7603f2ae0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTV8MHwxfHNlYXJjaHwxfHxjYW55b25pbmclMjBhZHZlbnR1cmV8ZW58MHx8fHwxNzgwODU3OTYyfDA&ixlib=rb-4.1.0&q=85",
      "https://images.unsplash.com/photo-1774982625681-7f9178c2ecfe?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTV8MHwxfHNlYXJjaHwzfHxjYW55b25pbmclMjBhZHZlbnR1cmV8ZW58MHx8fHwxNzgwODU3OTYyfDA&ixlib=rb-4.1.0&q=85",
    ],
    duration: { es: "4 - 5 horas", en: "4 - 5 hours" },
    difficulty: { es: "Iniciación a Avanzado", en: "Beginner to Advanced" },
    group: { es: "Mín. 2 - Máx. 8 personas", en: "Min. 2 - Max. 8 people" },
    price: "Desde 65€",
    priceEn: "From €65",
    title: { es: "Descenso de Barrancos", en: "Canyoning" },
    tagline: {
      es: "Toboganes naturales, rápeles bajo cascadas y aguas turquesas del Norte.",
      en: "Natural slides, waterfall rappels and turquoise pools of the North.",
    },
    description: {
      es: "Adéntrate en los desfiladeros más espectaculares de Vizcaya y Cantabria. Desciende rápeles entre cascadas, lánzate por toboganes esculpidos por el agua y nada en pozas de aguas cristalinas. Una experiencia inolvidable guiada por profesionales titulados.",
      en: "Discover the most spectacular gorges of Vizcaya and Cantabria. Rappel down waterfalls, slide on natural water-carved slides and swim in crystal-clear pools. An unforgettable experience led by certified guides.",
    },
    includes: {
      es: [
        "Equipo técnico completo (neopreno, casco, arnés)",
        "Guía profesional titulado",
        "Seguro de accidentes y RC",
        "Reportaje fotográfico digital",
        "Transporte desde punto de encuentro",
      ],
      en: [
        "Complete technical gear (wetsuit, helmet, harness)",
        "Certified professional guide",
        "Accident & liability insurance",
        "Digital photo report",
        "Transport from meeting point",
      ],
    },
  },
  {
    slug: "cuevas",
    image: "https://images.pexels.com/photos/17405149/pexels-photo-17405149.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    gallery: [
      "https://images.pexels.com/photos/17405149/pexels-photo-17405149.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
      "https://images.unsplash.com/photo-1518709268805-4e9042af2176?auto=format&fit=crop&w=1200&q=80",
    ],
    duration: { es: "3 - 6 horas", en: "3 - 6 hours" },
    difficulty: { es: "Iniciación a Técnico", en: "Beginner to Technical" },
    group: { es: "Mín. 2 - Máx. 6 personas", en: "Min. 2 - Max. 6 people" },
    price: "Desde 55€",
    priceEn: "From €55",
    title: { es: "Espeleología en Cuevas", en: "Caving Expeditions" },
    tagline: {
      es: "Explora el corazón silencioso de las montañas del Norte.",
      en: "Explore the silent heart of the Northern mountains.",
    },
    description: {
      es: "Sumérgete en el mundo subterráneo de Cantabria y Vizcaya, regiones de cuevas únicas en Europa. Recorre galerías, salas con formaciones milenarias y descubre la geología que esculpió este territorio. Diferentes niveles desde rutas familiares hasta travesías técnicas con rápeles.",
      en: "Dive into the underground world of Cantabria and Vizcaya, a region of caves unique in Europe. Walk through galleries, chambers with millennia-old formations and discover the geology that shaped this land. Multiple levels from family routes to technical traverses with rappels.",
    },
    includes: {
      es: [
        "Casco con frontal LED",
        "Mono de espeleología y botas",
        "Guía espeleólogo profesional",
        "Seguro y permisos de acceso",
        "Briefing geológico y de seguridad",
      ],
      en: [
        "Helmet with LED headlamp",
        "Caving overalls and boots",
        "Professional caving guide",
        "Insurance and access permits",
        "Geological and safety briefing",
      ],
    },
  },
  {
    slug: "ferratas",
    image: "https://images.unsplash.com/photo-1667169601500-89aac6e9a73f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNDR8MHwxfHNlYXJjaHwzfHx2aWElMjBmZXJyYXRhJTIwY2xpbWJpbmd8ZW58MHx8fHwxNzgwODU3OTYyfDA&ixlib=rb-4.1.0&q=85",
    gallery: [
      "https://images.unsplash.com/photo-1667169601500-89aac6e9a73f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNDR8MHwxfHNlYXJjaHwzfHx2aWElMjBmZXJyYXRhJTIwY2xpbWJpbmd8ZW58MHx8fHwxNzgwODU3OTYyfDA&ixlib=rb-4.1.0&q=85",
      "https://images.unsplash.com/photo-1551632811-561732d1e306?auto=format&fit=crop&w=1200&q=80",
    ],
    duration: { es: "3 - 5 horas", en: "3 - 5 hours" },
    difficulty: { es: "K1 a K5", en: "K1 to K5" },
    group: { es: "Mín. 2 - Máx. 6 personas", en: "Min. 2 - Max. 6 people" },
    price: "Desde 60€",
    priceEn: "From €60",
    title: { es: "Vías Ferratas", en: "Via Ferratas" },
    tagline: {
      es: "Escala paredes verticales con seguridad y vistas infinitas.",
      en: "Climb vertical walls safely with infinite views.",
    },
    description: {
      es: "Recorre las vías ferratas más impresionantes del País Vasco y Cantabria. Trepa por grapas y cables de acero asegurado en todo momento, supera puentes tibetanos y disfruta de panorámicas únicas del Cantábrico. Aventura vertical apta desde principiantes hasta expertos.",
      en: "Tackle the most impressive via ferratas of the Basque Country and Cantabria. Climb on metal staples and steel cables, always safely secured, cross Tibetan bridges and enjoy unique views of the Cantabrian coast. Vertical adventure for beginners to experts.",
    },
    includes: {
      es: [
        "Arnés, casco y disipador homologado",
        "Guía técnico deportivo titulado",
        "Seguro de accidentes y RC",
        "Briefing técnico y de progresión",
        "Reportaje fotográfico",
      ],
      en: [
        "Harness, helmet and certified energy absorber",
        "Qualified technical sports guide",
        "Accident & liability insurance",
        "Technical and progression briefing",
        "Photo report",
      ],
    },
  },
];

export const getActivity = (slug) => activities.find((a) => a.slug === slug);
